// import "../../js/vendor/skycons.js";

export const propertyMap = [ function () {
    return {
        link: function(scope, elem, attrs) {
            function richman_maps() {
                let map_el = elem[0]
                if (map_el) {
                    var markers = [];
                    var prop_location = new google.maps.LatLng(attrs.lat, attrs.lng);
                    var directionsDisplay = new google.maps.DirectionsRenderer();
                    var directionsService = new google.maps.DirectionsService();
                    var infowindow = new google.maps.InfoWindow();

                    var map = new google.maps.Map(map_el, {
                        center: prop_location,
                        zoom: 15,
                        scrollwheel: false
                    });
                    var main_marker = new google.maps.Marker({
                        map: map,
                        icon: richman_app_vars['theme_uri']+'/img/ic_place_black_24px.svg',
                        position: prop_location,
                    });
                    function showMainMarkerInfo() {
                        infowindow.setContent(`<div>
                            <div>
                                <a target="_blank" href="https://maps.google.com/maps?z=12&t=m&q=${attrs.address}"><strong>${attrs.prop}</strong></a>
                            </div>
                            ${attrs.address}
                            <p class="hideifempty">${attrs.desc}</p>
                        </div>`);
                        infowindow.open(map, main_marker);
                    }
                    showMainMarkerInfo();
                    google.maps.event.addListener(main_marker, 'click', function(event) {
                        showMainMarkerInfo();
                    });


                    // Specify location, radius and place types for your Places API search.
                    // Create the PlaceService and send the request.
                    // Handle the callback with an anonymous function.
                    var service = new google.maps.places.PlacesService(map);
                    function places_search(request) {
                        service.nearbySearch(request, function(results, status) {
                            if (status == google.maps.places.PlacesServiceStatus.OK) {
                                for (var i = 0; i < results.length; i++) {
                                    var place = results[i];

                                    var marker = new google.maps.Marker({
                                        // map: map,
                                        position: place.geometry.location
                                    });
                                    // register an event to handle a click on the marker to show details


                                    getPlaceDetails(place.place_id, marker);
                                    google.maps.event.addListener(marker, 'click', function() {
                                    });

                                    markers.push(marker);
                                }
                                // add markers to map
                                for (let marker of markers) {
                                    marker.setMap(map);
                                }
                            }
                        });
                    }
                    function getPlaceDetails(place_id, marker) {
                        google.maps.event.addListener(marker, 'click', function(event) {
                            service.getDetails({placeId: place_id}, function(details){
                                // console.log('details ' , details);
                                if (status === google.maps.places.PlacesServiceStatus.OK) {}
                                infowindow.setContent(`<div>
                                    <div>
                                        <a target="_blank" href="${details.url}"><strong>${details.name}</strong></a>
                                    </div>
                                    <div>
                                        <a target="_blank" href="${details.website}">View Website</a>
                                    </div>
                                    ${details.vicinity}
                                </div>`);
                                infowindow.open(map, marker);
                            });
                        });
                    }

                    let actions = Array.prototype.slice.call(document.querySelectorAll('.cp-Map_Action'));
                    if (actions) {
                        for (const action of actions) {
                            action.addEventListener('click', function(e) {
                                for (const f of actions) {
                                    f.classList.remove('js-Active');
                                }
                                action.classList.add('js-Active');
                                var request = {
                                    location: prop_location,
                                    radius: '2000',
                                    types: action.getAttribute('data-type').split(','),
                                };
                                map.panTo(prop_location);
                                // remove old markers from map if they exists
                                if (markers) {
                                    for (const marker of markers) {
                                        marker.setMap(null);
                                    }
                                    markers = [];
                                }
                                // make a new places search
                                places_search(request);
                            })
                        }
                    }

                    let clearRoute = document.getElementById('js-ClearRoute');
                    if (clearRoute) {
                        clearRoute.addEventListener('click', function(e) {
                            document.querySelector('.cp-Map_RouteResult').classList.remove('js-Active');
                            directionsDisplay.setMap(null);
                        });
                    }

                    let getRoute = document.getElementById('js-GetRoute');
                    if (getRoute) {
                        getRoute.addEventListener('submit', function(e) {
                            calcRoute();
                        });
                    }

                    function calcRoute() {
                        directionsDisplay.setMap(map);
                        var start = prop_location;
                        var end = document.getElementById('cp-Map_CommuteInput').value;
                        var request = {
                            origin:start,
                            destination:end,
                            travelMode: google.maps.TravelMode.DRIVING
                        };
                        directionsService.route(request, function(result, status) {
                            if (status == google.maps.DirectionsStatus.OK) {
                                directionsDisplay.setDirections(result);
                                document.querySelector('.cp-Map_RouteResult').classList.add('js-Active');
                                document.getElementById('js-GetRouteResult').innerHTML = result.routes[0].legs[0].duration.text;
                            }
                        });
                    }
                } // if (map_el)
            }
            richman_maps();
        }
    }
}];

